import Vitals from './Vitals';

export default Vitals;
